type LocalPreferences = {
  [key: string]: string;
};

export type { LocalPreferences };
